import React, { useEffect, useContext } from 'react';
import BlastreamPlayer from '../../BlastreamPlayer';
import { Context } from '../PlayerBuilderContext';
import { InitOptions } from '../../types/player';

function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

let currentDiffOptions: InitOptions = {
    source: {

    }
};

let timeoutPlayer: any;
let timeout: any;
let currentOptions: InitOptions;
let urlParams = new URLSearchParams(window.location.search);
let hasDeveloper = urlParams.get('developer');
function deepCompare(leftChain: any, rightChain: any) {
    var i, l;
  
    function compare2Objects (x: any, y: any) {
      var p;
  
      // remember that NaN === NaN returns false
      // and isNaN(undefined) returns true
      if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
           return true;
      }
  
      // Compare primitives and functions.     
      // Check if both arguments link to the same object.
      // Especially useful on the step where we compare prototypes
      if (x === y) {
          return true;
      }
  
      // Works in case when functions are created in constructor.
      // Comparing dates is a common scenario. Another built-ins?
      // We can even handle functions passed across iframes
      if ((typeof x === 'function' && typeof y === 'function') ||
         (x instanceof Date && y instanceof Date) ||
         (x instanceof RegExp && y instanceof RegExp) ||
         (x instanceof String && y instanceof String) ||
         (x instanceof Number && y instanceof Number)) {
          return x.toString() === y.toString();
      }
  
      // At last checking prototypes as good as we can
      if (!(x instanceof Object && y instanceof Object)) {
          return false;
      }
  
      if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
          return false;
      }
  
      if (x.constructor !== y.constructor) {
          return false;
      }
  
      if (x.prototype !== y.prototype) {
          return false;
      }
  
      // Check for infinitive linking loops
      if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
           return false;
      }
  
      // Quick checking of one object being a subset of another.
      // todo: cache the structure of arguments[0] for performance
      for (p in y) {
          if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
              return false;
          }
          else if (typeof y[p] !== typeof x[p]) {
              return false;
          }
      }
  
      for (p in x) {
          if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
              return false;
          }
          else if (typeof y[p] !== typeof x[p]) {
              return false;
          }
  
          switch (typeof (x[p])) {
              case 'object':
              case 'function':
  
                  leftChain.push(x);
                  rightChain.push(y);
  
                  if (!compare2Objects (x[p], y[p])) {
                      return false;
                  }
  
                  leftChain.pop();
                  rightChain.pop();
                  break;
  
              default:
                  if (x[p] !== y[p]) {
                      return false;
                  }
                  break;
          }
      }
  
      return true;
    }
  
    if (arguments.length < 1) {
      return true; //Die silently? Don't know how to handle such case, please help...
      // throw "Need two or more arguments to compare";
    }
  
    for (i = 1, l = arguments.length; i < l; i++) {
  
        leftChain = []; //Todo: this can be cached
        rightChain = [];
  
        if (!compare2Objects(arguments[0], arguments[i])) {
            return false;
        }
    }
  
    return true;
}

export default function Player() {

    const { diffOptions, css, js, optionsOverride }: any = useContext(Context);

    const player = React.useRef(null);
    
    function mergeOptions(options: InitOptions, css: string, js: string, optionsOverride: string): InitOptions {
        let optionsOverrideObj = {}
        try {
            optionsOverrideObj = JSON.parse(optionsOverride) as InitOptions;
        }
        catch(err) {

        }
        //merge options and optionsOverride 
        let opt: InitOptions = {
            ...options,
            ...optionsOverrideObj,
            css: css,
            js: js
        } as InitOptions;
        return opt;
    }

    useEffect(() => {
        async function init() {

            while (player.current === null) {
                await sleep(100);
            }

            updatePlayer(diffOptions, css, js, optionsOverride);
            
        }

        init();

    }, []);

    /*events.on('diffOptions', (data: any) => {
        console.log('diffOptions', data);
        if(player.current === null) return;                
        new BlastreamPlayer(player.current as HTMLElement, data);
    });*/

    useEffect(() => {
        
        if(player.current === null) return;
        updatePlayer(diffOptions, css, js, optionsOverride);
       
    }, [diffOptions]);

    
    useEffect(() => {
        
        if(timeout)
            clearTimeout(timeout);
                        
        timeout = setTimeout(() => {
            if(player.current === null) return;
            updatePlayer(diffOptions, css, js, optionsOverride);
        }, 2000)        
       
    }, [css, js, optionsOverride]);

    
    function updatePlayer(diffOptions: InitOptions, css: string, js: string, optionsOverride: string) {
        
        if(player.current === null) return;
        let opt = mergeOptions(diffOptions, css, js, optionsOverride);
        console.log('deepCompare', currentDiffOptions, diffOptions);
        if(deepCompare(currentOptions, opt))
            return;
        if(deepCompare(currentDiffOptions, diffOptions))
            return;
        console.log('deepCompare OK', currentDiffOptions, diffOptions);
        //first = false;
        currentDiffOptions = diffOptions;
        let el = player.current as HTMLElement;
        el.innerHTML = 'Re-rendering player...';
        if(timeoutPlayer)
            clearTimeout(timeoutPlayer);
        timeoutPlayer = setTimeout(() => {
            currentOptions = opt;      
            new BlastreamPlayer(el, opt);
            if(hasDeveloper && window.parent) {
               window.parent.postMessage({ type: 'BlastreamPlayerOptData', data: {
                    diffOptions, css, js, optionsOverride
                }}, '*');
            }
        }, 300)
    }
    
    return (
        <div style={{ height: '100%' }} ref={player}>
        </div>
    );
}
